// Shared by InstrumentCard's list row and the list header in
// InstrumentAreaList so the header columns stay aligned with the rows.
// The actions block (EDIT + kebab menu) is pinned to the right of the row and
// never shrinks, so it can't be clipped when the data columns run out of room.
export const INSTRUMENT_LIST_ACTIONS_WIDTH = 148;
export const INSTRUMENT_LIST_ACTIONS_WIDTH_TOUCH = 184;

// Touch screens (tablets, iPads) get larger tap targets and spacing; see
// context/ui-requirements.md (used with gloves and safety goggles).
export const COARSE_POINTER = "@media (pointer: coarse)";
